<template>
    <v-card elevation="2" class="my-6">
        <v-app-bar color="#3F51B5" dark flat dense>
            <v-app-bar-title>Accounts ({{ list.length }})</v-app-bar-title>
            <v-spacer/>
            <v-btn icon @click="openCreateAccountDialog">
                <font-awesome-icon :icon="['fas', 'plus']" style="font-size: 20px;" fixed-width/>
            </v-btn>
        </v-app-bar>

    <!-- <v-card tile elevation="4" class="pa-0">
        <v-toolbar short flat color="white">
            <v-toolbar-title class="blue--text">{{label}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon color="blue" @click="openCreateAccountDialog">
                <font-awesome-icon :icon="['fas', 'plus']" style="font-size: 20px;" fixed-width/>
            </v-btn>
        </v-toolbar> -->
        <!-- <v-divider></v-divider> -->
        <v-list dense nav>
            <v-list-item v-if="list.length === 0">No accounts yet.</v-list-item>
            <v-list-item v-for="item in list" v-bind:key="item.id" class="my-2" @click="onClickItem(item.id)">
                <v-list-item-content class="text-start">
                    <AccountListItem :attr="item" :link="!selectOne"></AccountListItem>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-row justify="center" class="py-5" v-show="displayCreateAccount">
            <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
            <v-card elevation="4" class="px-10 pb-5 pt-8">
                <v-form v-model="createAccountForm" ref="createAccountFormRef" @submit.prevent="onSubmitForm" @keyup.enter.native="onSubmitForm">
                    <div v-if="add">
                        <v-select :items="addAccountChoices" v-model="addAccountId" label="Select an account"></v-select>
                    </div>
                    <div v-if="create">
                        <!--
                        <v-text-field
                            v-model=name
                            label="Name"
                            :rules="nameRules"
                            validate-on-blur
                            color="blue"
                            required
                            hint="What should we call you?"
                            autofocus
                            outlined
                        >
                                            <template v-slot:prepend>
                        <font-awesome-icon icon="account" fixed-width class="mt-1"/>
                    </template>
                        </v-text-field>
                        -->
                        <v-text-field
                            ref="nameInputRef"
                            v-model=newAccountName
                            label="Display Name"
                            :rules="newAccountNameRules"
                            validate-on-blur
                            color="blue"
                            required
                            hint="The name for the account"
                            type="text"
                            outlined
                        >
                        </v-text-field>

                    </div>
                    <v-row justify="center">
                        <v-card-actions>
                            <!-- <v-btn elevation="4" class="blue white--text" @click="addAccount" :disabled="!createAccountForm" v-if="add">
                                <font-awesome-icon icon="check" fixed-width/>
                                <span class="ml-2">Add</span>
                            </v-btn> -->
                            <v-btn elevation="4" class="blue white--text" @click="onSubmitForm" :disabled="!createAccountForm">
                                <font-awesome-icon icon="check" fixed-width/>
                                <span class="ml-2">Create</span>
                            </v-btn>
                        </v-card-actions>
                    </v-row>
                </v-form>
            </v-card>
            </v-col>
        </v-row>
        <CreateAccountDialog v-model="createAccountDialogVisible" @cancel="createAccountDialogVisible = false" @created="onAccountCreated"/>
    </v-card>
</template>

<script>
import AccountListItem from '@/components/list-item/AccountListItem.vue';
import CreateAccountDialog from '@/components/service-dashboard/CreateAccountDialog.vue';
import { isValidName, compact } from '@/sdk/input';

export default {
    components: {
        AccountListItem,
        CreateAccountDialog,
    },

    props: {
    },

    data() {
        return {
            list: [],
            submitFormTimestamp: null,
            createAccountDialogVisible: false,
            // create account
            displayCreateAccount: false,
            createAccountForm: null,
            newAccountName: null,
            newAccountNameRules: [
                (v) => !!v || 'Display name is required',
                (v) => !v || isValidName(compact(v)) || 'Account name is required',
            ],
            // add account
            addAccountChoices: [],
            addAccountId: null,
        };
    },

    computed: {
        id() {
            return this.policyId;
        },
        label() {
            if (this.selectOne) {
                return 'Select an account';
            }
            switch (this.list.length) {
            case 0:
                return 'No accounts';
            case 1:
                return '1 account';
            default:
                return `${this.list.length} accounts`;
            }
        },
    },

    watch: {
        displayCreateAccount(value) {
            if (value && (this.add || this.create)) {
                this.initAddAccountChoices();
            }
        },
    },

    methods: {
        async loadAccountList() {
            try {
                this.$store.commit('loading', { loadAccountList: true });
                const response = await this.$client.user(this.$store.state.session.userId).user.getAccountList();
                if (response?.list) {
                    this.list = response.list;
                }
            } catch (err) {
                console.error('loadAccountList failed', err);
            } finally {
                this.$store.commit('loading', { loadAccountList: false });
            }
        },
        onClickItem(accountId) {
            // if (this.selectOne) {
            //     this.$emit('selected', { accountId });
            // }
            this.$router.push({ name: 'account-dashboard', params: { accountId } });
        },
        openCreateAccountDialog() {
            this.createAccountDialogVisible = true;
        },
        async createAccount() {
            this.error = false;
            console.log('createAccount');
            const request = {
                // name: this.name,
                name: this.newAccountName,
                // agreeToTerms: this.isAgreeToTermsChecked,
                // interactionId: this.interactionId, // will be present if account arrives from an existing interaction, such as clicking on a specific link to get started and we can use this to redirect the account to an appropriate location after account is created
            };
            const response = await this.$client.user(this.$store.state.session.userId).user.createAccount(request);
            console.log('createAccount response: %o', response);
            const { isCreated, id, error } = response;
            if (isCreated) {
                const account = { id, ...request };
                this.list.push(account); // this SHOULD work (https://vuejs.org/v2/guide/list.html#Mutation-Methods) but doesn't work.
                this.$emit('created-account', account);
                this.$emit('added-account', account);
                this.displayCreateAccount = false;
                this.newAccountName = null;
            } else if (error) {
                this.error = error;
            } else {
                this.error = 'Request failed';
            }
        },
        onSubmitForm() {
            if (Number.isInteger(this.submitFormTimestamp) && this.submitFormTimestamp + 500 > Date.now()) {
                return;
            }
            this.submitFormTimestamp = Date.now();
            if (this.$refs.createAccountFormRef.validate()) {
                this.createAccount();
            }
        },
        onAccountCreated() {
            this.createAccountDialogVisible = false;
            this.loadAccountList();
        },
        async addAccount() {
            const account = { id: this.addAccountId, label: this.addAccountChoices.find((item) => item.value === this.addAccountId).text };
            this.list.push(account);
            this.$emit('added-account', account);
            this.displayCreateAccount = false;
            this.addAccountId = null;
        },
        async initAddAccountChoices() {
            // create a map of which account ids are already in the list
            const accountMap = {};
            this.list.forEach((item) => {
                accountMap[item.id] = true;
            });
            // when we show the add/create account dialog, load the list of available accounts to add to the policy (list of all accounts less the ones already in the policy)
            const result = await this.$client.user(this.$store.state.session.userId).user.getAccountList();
            console.log(`AccountViewList.vue fetch accounts result: ${JSON.stringify(result)}`);
            if (result && result.list) {
                // filter the results to remove accounts already in the policy, then convert the available accounts to a choice list for the v-select [ { text, value }, ... ]
                this.addAccountChoices = result.list.filter((item) => !accountMap[item.id]).map((item) => ({ text: item.name, value: item.id }));
            }
        },
    },

    mounted() {
        this.loadAccountList();
    },
};
</script>
